import React from "react";
import Card from "../../components/page/Card";
import LocalidadeApiClient from "../../api/localidade";
import TimelineApiClient from "../../api/timeline";
import useApi from "../../hooks/useApi";
import MeiDataTable from "./Mei/MeiDataTable";
import NovoMeiModal from "./Mei/NovoMeiModal";
import ProcessoMeiModal from "./Mei/ProcessoMeiModal";
import MeiCards from "./Mei/MeiCards";
import FinalizarMeiModal from "./Mei/FinalizarMeiModal";
import Format from "../../helpers/Format";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonsApiClient from "../../api/commons";

function Mei() {
  const [values, setValues] = React.useState({});
  const [cards, setCards] = React.useState({});
  const [processos, setProcessos] = React.useState([]);
  const [novoProcessoModal, setNovoProcessoModal] = React.useState(false);
  const [processoMeiModal, setProcessoMeiModal] = React.useState(false);
  const [finalizarProcessoModal, setFinalizarProcessoModal] =
    React.useState(false);
  const [tabAtual, setTabAtual] = React.useState(0);

  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const { request: getCepEmpresa, data: cepResponseEmpresa } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const { request: getProcessos, data: procesosResponse } = useApi(
    TimelineApiClient.getProcessosMei
  );
  const novoProcessoMeiApi = useApi(TimelineApiClient.postProcessosMei);
  const deleteProcessoMeiApi = useApi(TimelineApiClient.deleteProcessoMei);
  const getProcessoMeiApi = useApi(TimelineApiClient.getProcessoMei);
  const putProcessoMeiApi = useApi(TimelineApiClient.putProcessoMei);
  const finalizarProcessoMeiApi = useApi(
    TimelineApiClient.finalizarProcessoMei
  );
  const documentoRouteApi = useApi(CommonsApiClient.documentoRoute);

  //Busca processos ao renderizar tela
  React.useLayoutEffect(() => {
    getProcessos();
  }, [getProcessos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (!procesosResponse) return;
    const transformedProcessos = procesosResponse.map((linha) => ({
      ...linha,
      dados_empresa: JSON.parse(linha.dados_empresa),
    }));

    const processos = transformedProcessos.length;
    const valor_total = transformedProcessos.reduce((accumulator, processo) => {
      const mensalidade = parseFloat(processo?.dados_empresa?.mensalidade) || 0;
      return accumulator + (Number.isNaN(mensalidade) ? 0 : mensalidade);
    }, 0);
    const ticket_medio = processos > 0 ? valor_total / processos : 0;

    setCards({
      valor_total,
      processos,
      ticket_medio,
    });
    setProcessos(transformedProcessos);
  }, [procesosResponse]);

  const togNovoProcessoModal = () => {
    setValues({});
    setNovoProcessoModal(true);
  };

  const togProcessoAutonomoModal = async (uid) => {
    const response = await getProcessoMeiApi.request(uid);
    if (!response) return;
    const dados = response?.dados_empresa;
    const {
      dados_pessoais = {},
      endereco = {},
      dados_empresa = {},
      endereco_empresa = {},
    } = dados;

    setValues({
      ...response,
      ...dados,
      ...dados_pessoais,
      ...endereco,
      email: dados.email_empresa,
      atividades_empresa: dados_empresa.atividades_empresa,
      nome_fantasia: dados_empresa.nome_fantasia,
      celular_empresa: dados_empresa.celular,
      email_empresa: dados_empresa.email,
      cod_cidade: endereco_empresa.cod_cidade,
      cep_empresa: endereco_empresa.cep,
      logradouro_empresa: endereco_empresa.logradouro,
      numero_empresa: endereco_empresa.numero,
      compl_empresa: endereco_empresa.compl,
      bairro_empresa: endereco_empresa.bairro,
      cidade_empresa: endereco_empresa.cidade,
      uf_empresa: endereco_empresa.uf,
      empresa_id: uid,
      codigo_cidade: endereco?.cod_cidade,
      codigo_cidade_empresa: endereco_empresa?.cod_cidade,
      cnh_rg_novo: dados_pessoais?.documento,
    });
    setTabAtual(0);
    setProcessoMeiModal(true);
  };

  const togFinalizarProcessoModal = (processo, uid) => {
    setValues({
      uid,
      razao_social: processo.razao_social,
    });
    setFinalizarProcessoModal(true);
  };

  const criarNovoProcesso = async () => {
    const formData = new FormData();
    formData.append("link_contrato", values?.link_contrato);
    formData.append("data_assinatura", values?.data_assinatura);
    formData.append("mensalidade", values?.mensalidade);
    formData.append("cnpj", Format.formatCNPJCPF(values?.cpf_empresa));
    formData.append("razao_social", values?.apelido_empresa);
    formData.append("email_empresa", values?.email_empresa);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (Validation.validaCpf(values?.cpf_empresa))
      return ErrorSwal({
        text: "Favor inserir um CNPJ válido.",
      });

    if (Validation.validarEmail(values?.email_empresa))
      return ErrorSwal({
        text: "Favor inserir um e-mail válido.",
      });

    const response = await novoProcessoMeiApi.request(formData);
    if (!response) return;
    CommonSwal({ title: "Novo processo criado com sucesso!", icon: "success" });
    setNovoProcessoModal(false);
    getProcessos();
  };

  const deletarProcesso = (uid) => {
    OptionsSwal({
      icon: "question",
      title: "Você realmente deseja excluir esse processo?",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteProcessoMeiApi.request(uid);

        if (!response) return;
        CommonSwal({
          title: "Processo de abertura deletado",
          icon: "success",
        });
        getProcessos();
      }
    });
  };

  const downloadDocumento = async (caminho) => {
    const response = await documentoRouteApi.request(caminho, {
      ext: "pdf",
      type: "download",
    });
    if (!response) return;
    const blob = new Blob([response]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${caminho}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const salvarProcesso = async () => {
    const formData = new FormData();
    formData.append("empresa_id", values?.empresa_id);
    formData.append("data_nascimento", values?.data_nascimento);
    formData.append("rg", values?.rg);
    formData.append("expedidor_rg", values?.expedidor_rg);
    formData.append("celular", values?.celular);
    formData.append("senha_gov", values?.senha_gov);
    formData.append("cep", values?.cep);
    formData.append("logradouro", values?.logradouro);
    formData.append("numero", values?.numero);
    formData.append("bairro", values?.bairro);
    formData.append("cidade", values?.cidade);
    formData.append("codigo_cidade", values?.codigo_cidade);
    formData.append("uf", values?.uf);
    formData.append("celular_empresa", values?.celular_empresa);
    formData.append("email_empresa", values?.email_empresa);
    formData.append("cep_empresa", values?.cep_empresa);
    formData.append("logradouro_empresa", values?.logradouro_empresa);
    formData.append("numero_empresa", values?.numero_empresa);
    formData.append("bairro_empresa", values?.bairro_empresa);
    formData.append("cidade_empresa", values?.cidade_empresa);
    formData.append("codigo_cidade_empresa", values?.codigo_cidade_empresa);
    formData.append("uf_empresa", values?.uf_empresa);
    formData.append("cnh_rg_novo", values?.cnh_rg_novo);

    if (values?.cep && !values?.codigo_cidade)
      return ErrorSwal({
        text: "Favor inserir um CEP válido.",
      });

    if (values?.cep_empresa && !values?.codigo_cidade_empresa)
      return ErrorSwal({
        text: "Favor inserir um CEP válido.",
      });

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (Validation.validarEmail(values?.email_empresa))
      return ErrorSwal({
        text: "Favor preencher com um e-mail válido.",
      });

    formData.append("atividades_empresa", values?.atividades_empresa || "");
    formData.append("nome_fantasia", values?.nome_fantasia || "");
    formData.append("compl", values?.compl || "");
    formData.append("compl_empresa", values?.compl_empresa || "");

    const response = await putProcessoMeiApi.request(
      values?.empresa_id,
      formData
    );
    if (!response) return;
    CommonSwal({ title: "Dados salvos com sucesso!", icon: "success" });
    setProcessoMeiModal(false);
    getProcessos();
  };

  const finalizarProcesso = async () => {
    try {
      const formData = new FormData();

      let empresa = values?.razao_social.replace(/[^a-zA-Z0-9 ]/g, "");
      empresa = empresa.replace(/[ ]/g, "_");

      formData.append("empresa", empresa);
      formData.append("cnpj_empresa", Format.formatCNPJCPF(values?.cnpj));
      formData.append("nome_empresa", values?.razao_social);
      formData.append("contabilidade", "Orangiuz");

      formData.append("email", values?.email);
      formData.append("usuario", values?.usuario);
      formData.append("senha", values?.senha);
      formData.append("cnpj", values?.cnpj);

      formData.append("cartao_cnpj", values?.cartao_cnpj);
      formData.append("ccmei", values?.ccmei);

      if (Validation.verificarForm(formData))
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

      if (values?.senha !== values?.confirme_senha)
        return ErrorSwal({ text: "As senhas devem ser iguais." });

      if (Validation.validarEmail(values?.email))
        return ErrorSwal({
          text: "Favor preencher com um e-mail válido.",
        });

      const senhaErro = Validation.verificarSenha(values?.senha);
      if (senhaErro)
        return ErrorSwal({
          html: senhaErro,
        });

      if (Validation.validaCnpj(values?.cnpj))
        return ErrorSwal({
          text: "Favor inserir um CNPJ válido.",
        });

      const response = await finalizarProcessoMeiApi.request(
        values?.uid,
        formData
      );
      if (!response) return;
      CommonSwal({
        title: "Processo finalizado com sucesso!",
        icon: "success",
      });
      setFinalizarProcessoModal(false);
      getProcessos();
    } catch (e) {
      console.warn(e);
    }
  };

  return (
    <>
      <div className="row">
        <MeiCards cards={cards} />
      </div>
      <Card>
        <MeiDataTable
          deletarProcesso={deletarProcesso}
          finalizarProcesso={togFinalizarProcessoModal}
          linhas={processos}
          togNovoProcessoModal={togNovoProcessoModal}
          togProcessoModal={togProcessoAutonomoModal}
        />
      </Card>
      <NovoMeiModal
        criarNovoProcesso={criarNovoProcesso}
        modalHook={{ novoProcessoModal, setNovoProcessoModal }}
        valuesHook={{ values, setValues }}
      />
      <ProcessoMeiModal
        cepApi={{ getCep, cepResponse }}
        cepEmpresaApi={{ getCepEmpresa, cepResponseEmpresa }}
        downloadDocumento={downloadDocumento}
        modalHook={{ processoMeiModal, setProcessoMeiModal }}
        salvarProcesso={salvarProcesso}
        tabHook={{ tabAtual, setTabAtual }}
        valuesHook={{ values, setValues }}
      />
      <FinalizarMeiModal
        valuesHook={{ values, setValues }}
        modalHook={{ finalizarProcessoModal, setFinalizarProcessoModal }}
        finalizarProcesso={finalizarProcesso}
      />
    </>
  );
}

export default Mei;
